import { Icon, IconProps } from '@chakra-ui/react'

type ArrowDropUpIconProps = Pick<IconProps, 'boxSize' | 'color'>

// https://materialui.co/icon/arrow-drop-up
const ArrowDropUpIcon: React.FC<ArrowDropUpIconProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M7 14l5-5 5 5z" fill="currentColor" />
  </Icon>
)

export default ArrowDropUpIcon
